import { useFormik } from 'formik';
import { Box, Button, FormField, Text, TextInput } from 'grommet';
import React, { useState } from 'react';
import { dispatchAction } from 'rxbeach';
import { object, string } from 'yup';
import { forgot } from '../stream/actions';

const validationSchema = object({
  email: string().email().required(),
});

const Forgot = () => {
  const [hasSubmitted, setSubmitted] = useState(false);
  const formik = useFormik({
    initialValues: {
      email: '',
    },
    validationSchema,
    onSubmit: ({ email }) => {
      dispatchAction(forgot({ email }));
      setSubmitted(true);
    },
  });
  return (
    <Box
      fill
      align="center"
      justify="center"
      pad="large"
      height={{ min: 'medium' }}
    >
      {!hasSubmitted && (
        <Box width="medium" gap="medium">
          <Text size="xlarge" weight="bold">
            Gjenopprett passord
          </Text>
          <Text size="medium">
            Ikke bekymre deg, vi har alle glemt et passord
          </Text>
          <FormField
            label="Email"
            error={formik.touched.email && formik.errors.email}
            required
          >
            <TextInput
              id="email"
              type="text"
              value={formik.values.email}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
          </FormField>

          <Box direction="row" gap="small" margin={{ top: 'medium' }}>
            <Button
              label="Send meg email med instruksjoner"
              primary
              onClick={() => formik.handleSubmit()}
            />
          </Box>
        </Box>
      )}
      {hasSubmitted && (
        <Box width="large" gap="medium">
          <Text size="xlarge" weight="bold">
            Email er sent
          </Text>
          <Text size="medium">
            En email med instruksjoner om hvordan du tilbakestiller passordet
            ditt er sendt til {formik.values.email}. Sjekk søppelposten din hvis
            du ikke ser emailen i innboksen.
          </Text>
          <Text>
            Hvis du ikke lenger har tilgang til denne email kontoen, kan du
            kontakte oss.
          </Text>
        </Box>
      )}
    </Box>
  );
};

export default Forgot;
